"use strict";

/**
* Handles the click event on the modal video button and shows the modal video
* @param {Object} $modalButtons - jQuery object of the modal video buttons
*/
const modalOpenBtnListener = () => {
    const $modalButtons = $(".js-btn-open-modal-video");

    $modalButtons.on("click", function () {
        const $buttonClicked = $(this);
        const $componentContainer = $buttonClicked.parents(".js-pd-modal-video");
        const $modalContainer = $(".js-video-modal-container", $componentContainer);

        $modalContainer.modal("show");

        $modalContainer.on("hidden.bs.modal", function () {
            stopHiddenVideosFromPlaying($modalContainer);
        });

        autoStartPlayer($modalContainer);
    });
};

/**
* Pauses the YouTube video in the modal
* @param {Object} context - the context of the modal
*/
const stopHiddenVideosFromPlaying = (context) => {
    const $youTubeContainer = $(".js-modal-video", context);
    const $videoIframe = $youTubeContainer.children().get(0);

    window.players.filter(player => {
        if (player && player.g === $videoIframe) {
            player.pauseVideo();
        }
    });
};

/**
* Plays the video in the modal if auto play is enabled
* @param {Object} context - DOM element containing the video
*/
const autoStartPlayer = (context) => {
    const $youTubeContainer = $(".js-modal-video", context);
    const $videoIframe = $youTubeContainer.children().get(0);
    const autoPlay = $youTubeContainer.data("video-auto-play");

    if (autoPlay) {
        window.players.filter(player => {
            //If the player is ready and the video is the one in the modal, play the video
            if (player && player.g === $videoIframe) {
                if (Object.prototype.hasOwnProperty.call(player, "playVideo")) {
                    player.playVideo();
                }
            }
        });
    }
};

/**
* Initializes the modal video with content asset component.
* @param {Object} $container - jQuery object of the modal video with content asset component.
*/
$(document).ready(function () {
    const $container = $(".js-pd-modal-video");

    //If there's no modal video with content asset component, just abort the listener initializers calls.
    if ($container.length === 0) {
        return;
    }

    modalOpenBtnListener();
});
